import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DynamicFilterService } from '../dynamic-filter/dynamic-filter.service';

@Component({
  selector: 'app-dynamic-popup',
  templateUrl: './dynamic-popup.component.html',
  styleUrls: ['./dynamic-popup.component.scss']
})
export class DynamicPopupComponent  {

  formValues: { [key: string]: boolean } = {}; // To store checkbox states
  selectedOption: any = null;
  constructor(
    public dynamicFilterService: DynamicFilterService,
    public dialogRef: MatDialogRef<DynamicPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.dynamicFilterService.dynamicProcessMandatoryColumns.forEach((item:any) => {
      this.formValues[item] = false;
    });
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    this.dialogRef.close({ confirmed: true, value: this.formValues, selectedOption: this.selectedOption });
  }

  onCheckboxChange(key: string, event:any): void {
    this.formValues[key] = event.target.checked; // Update the value dynamically
    console.log( event.target.checked);
    
    console.log(this.formValues); // Log the current state
  }

  isThemeColor(color: string): boolean {
    return ['primary', 'accent', 'warn'].includes(color?.toLowerCase());
  }

  resolveBackgroundColor(color: string): string {
    const materialColors: { [key: string]: string } = {
      primary: '#1363Df',
      accent: '#FFCD4A',
      warn: '#E70D0D'
    };

    if (!color) return '';

    // Check if it's a known Material alias
    if (materialColors[color]) {
      return materialColors[color];
    }

    // Otherwise, assume it's a valid CSS color
    return color;
  }

}
